import { taskIcons } from 'configs';
import React from 'react';
import { components } from 'react-select';

const ValueOption = (props) => {
  const { SingleValue } = components;
  const {
    data: { value },
  } = props;
  const Icon = taskIcons[value];

  return (
    <SingleValue {...props}>
      <Icon />
    </SingleValue>
  );
};

export default ValueOption;
